import React from 'react';
import { FiFilter } from '@react-icons/all-files/fi/FiFilter';
import { ButtonStyle, StyledWrapper, Wrapper, Logo } from './RiskFilterButtonStyle';
import { IconContext } from 'react-icons';
import Normal from '../../../assets/img/unflag_bttn.svg';
import Flag from '../../../assets/img/flag_bttn.svg';
import styled from 'styled-components';
import { pushShowApplyReco } from '../../../slices/ButtonsSlice';
import { pushShowCard, pushCancelEvent, pushChipArray, pushSearchChipArray, setSearchString } from '../../../slices/RiskFilterSlice';
import { useDispatch, useSelector } from 'react-redux';
import FilterQueryCard from '../../Filter/FilterQueryCard';
import DefineQuery from '../../Filter/DefineQuery';
import ExportToExcel from './ExportToExcel';
import DropDownMenu from '../../Application/DropDownMenu/DropDownMenu';
import Button from '@material-ui/core/Button';
const StyledButton = styled(Button)`
  && {
    background: ${props => props.watch ? '#ddedf9' : 'white'};
    color: ${props => props.watch ? '#005099' : '#212121'} !important;
    font-size: 13px;
    border: 0px !important;
    cursor: pointer;
    min-width: 24px;
    text-transform: none;
    height: 36px;
    &:hover {
      background-color: rgba(0, 0, 0, 0.04);
    }
    span {
      margin-left: 3px !important;
    }
  }
`;
const StyledFiFilter = styled(FiFilter)`
  color: ${props => !props.showApplyReco && !props.showCard && !props.applyEvent ? '#212121' : '#0461A7'};
`;
const StyledSpan = styled.span`
  display: inline-block;
  margin-left: 3px !important;
  margin-top: 1px !important;
  color: ${props => !props.showApplyReco && !props.showCard && !props.applyEvent ? '#212121' : '#0461A7'};
`;

const RecommendationFilter = props => {
  const dispatch = useDispatch();
  const applyEvent = useSelector(state => state.riskFilterSlice.applyEvent);
  const showCard = useSelector(state => state.riskFilterSlice.showCard);
  const cancelEvent = useSelector(state => state.riskFilterSlice.cancelEvent);
  const showApplyReco = useSelector(state => state.buttonSlice.showApplyReco);
  const recoReqBody = useSelector(state => state.riskFilterSlice.recoReqBody);
  let recommendationColumnData = useSelector(state => state.recommendationTable.recommendationColumnData) || [];
  let recommendationApplicationColumnData = useSelector(state => state.recommendationTable.recommendationApplicationColumnData) || [];
  let recommendationEnvironmentColumnData = useSelector(state => state.recommendationTable.recommendationEnvironmentColumnData) || [];
  let menuItems = [];

  if (props && props.pageType) {
    switch (props.pageType) {
      case 'application':
        menuItems = recommendationColumnData;
        break;

      case 'environment':
        menuItems = recommendationApplicationColumnData;
        break;

      case 'entity':
        menuItems = recommendationEnvironmentColumnData;
        break;

      default:
        break;
    }
  }

  const handleWatch = () => {
    if (props.watch === 0) {
      props.setWatch(1);
    } else {
      props.setWatch(0);
    }
  };

  var d = new Date();
  let year = d.getFullYear();
  let month = d.getMonth() + 1;
  let date = d.getDate();
  var dateVal = year + '-' + month + '-' + date;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledWrapper, {
    showApplyReco: showApplyReco,
    showCard: showCard
  }, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(ButtonStyle, {
    onClick: () => {
      dispatch(pushShowCard(true));
      dispatch(pushShowApplyReco(true));
      dispatch(pushCancelEvent(false));
      dispatch(pushChipArray([]));
      dispatch(pushSearchChipArray([]));
      dispatch(setSearchString(''));
    }
  }, /*#__PURE__*/React.createElement(StyledFiFilter, {
    showApplyReco: showApplyReco,
    showCard: showCard,
    applyEvent: applyEvent
  }), /*#__PURE__*/React.createElement(StyledSpan, {
    showApplyReco: showApplyReco,
    showCard: showCard,
    applyEvent: applyEvent
  }, "Filter")), !showApplyReco && !showCard || cancelEvent ? !applyEvent ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledButton, {
    watch: props.watch,
    onClick: () => handleWatch()
  }, props.watch === 0 ? /*#__PURE__*/React.createElement(Logo, {
    src: Normal
  }) : /*#__PURE__*/React.createElement(IconContext.Provider, {
    value: {
      color: '#005099'
    }
  }, ' ', /*#__PURE__*/React.createElement(Logo, {
    src: Flag
  })), /*#__PURE__*/React.createElement("span", null, "Watching")), /*#__PURE__*/React.createElement(ExportToExcel, {
    apiUrl: props.exportApi,
    apiRequestBody: recoReqBody,
    totalCount: props.totalCount,
    fileName: dateVal
  }), /*#__PURE__*/React.createElement(DropDownMenu, {
    menuItems: menuItems,
    isRiskTable: false,
    pageType: props.pageType
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledButton, {
    watch: props.watch,
    onClick: () => handleWatch()
  }, props.watch === 0 ? /*#__PURE__*/React.createElement(Logo, {
    src: Normal
  }) : /*#__PURE__*/React.createElement(IconContext.Provider, {
    value: {
      color: '#005099'
    }
  }, ' ', /*#__PURE__*/React.createElement(Logo, {
    src: Flag
  })), /*#__PURE__*/React.createElement("span", {
    className: "watchLabel"
  }, "Watching")), /*#__PURE__*/React.createElement(ExportToExcel, {
    apiUrl: props.exportApi,
    apiRequestBody: recoReqBody,
    totalCount: props.totalCount,
    fileName: dateVal
  }), /*#__PURE__*/React.createElement(DropDownMenu, {
    menuItems: menuItems,
    isRiskTable: false,
    pageType: props.pageType
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DefineQuery, {
    watch: props.watch
  })))), !showApplyReco && !showCard ? !applyEvent ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement(FilterQueryCard, null) : /*#__PURE__*/React.createElement(FilterQueryCard, null));
};

export default RecommendationFilter;